var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsian(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 288,
    style: {
      fill: "#F9BDA0"
    },
    width: 160,
    height: 168
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A9AD3"
    },
    d: "M461.528,329.856l-118.464-41.248l2.504-6.864l-15.496-6.568 C323.896,303.168,289.544,324.6,248,324.6c-41.56,0-75.896-21.488-82.064-49.48l-15.52,6.496l2.512,6.72L34.472,329.864L12,496 h29.952h152.744h46.32h13.968h48.464h150.6H484L461.528,329.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1982BC"
    },
    d: "M16,496h25.952h152.744h46.32h13.968h48.464h150.6H484l-22.472-166.144l-118.464-41.248l2.504-6.864 l-15.496-6.568C323.896,303.168,289.544,324.6,248,324.6c-41.56,0-75.896-21.488-82.064-49.48l-15.52,6.496l0.512,7.288"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11558C"
    },
    d: "M240,496h14.984h48.464h150.6H484l-22.472-166.144l-118.464-41.248l2.504-6.864l-15.496-6.568 c-6.176,27.992-41.032,49.992-82.584,49.992"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "282.544,7.368 263.32,5.672 258.168,16.992 250.192,0 248.784,0 247.216,0 245.816,0  237.832,16.992 232.68,5.384 213.456,7.224 234.48,48.032 248,51.104 248,51.464 248,51.288 248,51.464 248,51.104 261.528,48.104  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#10B5E8"
    },
    cx: 248,
    cy: 52.68,
    rx: 27.936,
    ry: 20.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "307.68,304 190.08,304 197.936,208 299.848,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "309.56,305.504 248.008,466.792 186.44,305.504 248.008,306.168  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "307.696,305.632 261.104,401.04 190.096,208 299.856,208 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M325.816,140.68c0-68.248-29.816-95.864-77.816-96.136v-0.032v0.016v-0.016v0.032 c-48,0.272-77.816,27.888-77.816,96.136S200,270.632,248,272.112v0.136c0,0,0-0.056,0-0.064c0,0.008,0,0.064,0,0.064v-0.136 C296,270.632,325.816,208.928,325.816,140.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M248,272v0.24c0,0,0-0.056,0-0.064c0,0.008,0,0.064,0,0.064v-0.136 c48-1.48,77.816-63.176,77.816-131.432S296,44.816,248,44.544v-0.032v0.016v-0.016V48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M169.952,119.976c-4.216-1.848-3.384-14.36,0.336-22.824c3.736-8.488,10.192-21.64,14.392-19.784 c4.232,1.856,7.728,20.248,0.912,26.496"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M327.816,119.792c4.232-1.864,3.44-14.36-0.28-22.832c-3.712-8.464-10.144-21.608-14.376-19.744 c-4.216,1.864-7.752,20.272-0.928,26.504"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M204.928,221.384c-0.192-0.216-0.304-0.36-0.304-0.36S204.704,221.24,204.928,221.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M292.848,221.384c0.2-0.216,0.304-0.36,0.304-0.36S293.08,221.24,292.848,221.384z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 166.464,
    cy: 319.16,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 177.2,
    cy: 348.712,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 187.912,
    cy: 378.24,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 198.624,
    cy: 407.824,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 209.36,
    cy: 437.384,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 220.064,
    cy: 466.96,
    r: 4.872
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 329.52,
    cy: 319.16,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 318.816,
    cy: 348.712,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 308.096,
    cy: 378.24,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 297.36,
    cy: 407.824,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 286.656,
    cy: 437.384,
    r: 4.872
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 275.936,
    cy: 466.96,
    r: 4.872
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsian);
export default __webpack_public_path__ + "static/media/asian.8ae372511fa2e1f38f8909a9c3bf60a2.svg";
export { ForwardRef as ReactComponent };